export const icons = {
  accessibility: 'mdi-human',
  add: 'mdi-plus-circle',
  alert: 'mdi-alert',
  arrowLeft: 'mdi-arrow-left',
  arrowRight: 'mdi-arrow-right',
  backspace: 'mdi-backspace',
  bullet: 'mdi-circle-small',
  cancel: 'mdi-close',
  cancelCircle: 'mdi-close-circle',
  categories: 'mdi-shape',
  close: 'mdi-close',
  create: 'mdi-plus',
  checkbox: {
    0: 'mdi-checkbox-blank-outline',
    1: 'mdi-checkbox-marked-outline',
  },
  departments: {
    department: 'mdi-account-multiple',
    marketing: 'mdi-email-newsletter',
  },
  details: 'mdi-file-document',
  developer: 'mdi-dev-to',
  duplicate: 'mdi-content-duplicate',
  edit: 'mdi-pencil',
  hamburger: 'mdi-menu',
  help: 'mdi-help-circle',
  link: 'mdi-link-variant',
  list: 'mdi-format-list-numbered',
  moveDown: 'mdi-arrow-down-bold',
  moveUp: 'mdi-arrow-up-bold',
  ok: 'mdi-check',
  save: 'mdi-check',
  saveCircle: 'mdi-check-circle',
  trash: 'mdi-trash-can',
  upload: 'mdi-upload',
  view: 'mdi-eye',
  webapp: 'mdi-cellphone',
  where: 'mdi-share-variant',
  zoom: 'mdi-magnify-scan',
  timeLineNotes: 'mdi-calendar-text',
  channels: {
    channels: 'mdi-pound',
  },
  communications: {
    icon: 'mdi-email-multiple-outline',
    communications: 'mdi-email-multiple',
    type: {
      sms: 'mdi-cellphone-basic',
      email: 'mdi-email',
    },
    status: {
      sent: 'mdi-check-circle',
      not_sent: 'mdi-clock-fast',
      error: 'mdi-alert-circle',
    },
  },
  contracts: {
    icon: 'mdi-note-text',
    renew: 'mdi-update',
  },
  invoices: {
    icon: 'mdi-invoice-list-outline',
  },
  laLiga: {
    competition: {
      icon: 'mdi-license',
      start: 'mdi-flag-checkered',
    },
  },
  lockers: {
    icon: 'mdi-locker-multiple',
    install: {
      icon: 'mdi-wrench',
      install: 'mdi-hammer-wrench',
      push: 'mdi-upload',
      reboot: 'mdi-cog-clockwise',
      image: 'mdi-image',
    },
    features: 'mdi-star-box-multiple-outline',
    locker: 'mdi-locker',
    cell: 'mdi-lock-open',
    cells: {
      cells: 'mdi-file-cabinet',
      features: {
        accessible: 'mdi-human',
      }
    },
  },
  orders: {
    icon: 'mdi-package-variant-closed',
    orders: 'mdi-package-variant-closed',
    order: {
      lockerCode: 'mdi-dialpad',
      createdAt: 'mdi-airplane-takeoff',
      due: 'mdi-airplane-landing',
    },
    types: {
      amazon_return: 'mdi-package-variant',
      bizcocho_order: 'mdi-cake-variant',
      custom: 'mdi-progress-wrench',
      delivey_with_code: 'mdi-truck-fast',
      drop_only: 'mdi-exit-to-app',
      home_delivery: 'mdi-home',
      internal_delivery_1: 'mdi-package-variant-closed',
      laundry_drop_go: 'mdi-tshirt-crew',
      locker_order: 'mdi-locker',
      office_order: 'mdi-square-edit-outline',
      packageTransfer: 'mdi-transfer',
      public_locker: 'mdi-locker-multiple',
      smart_drop: 'mdi-gift',
      smart_storage: 'mdi-barn',
      unknown: 'mdi-progress-wrench',
    },
    delivery: 'mdi-dolly',
    CTA: {
      assemble: 'mdi-check',
      collect: 'mdi-airplane-takeoff',
      confirm: 'mdi-clipboard-check-outline',
      deliver: 'mdi-airplane-takeoff',
      pay: 'mdi-cash-check',
      resendConfirmation: 'mdi-email',
      unPay: 'mdi-cash-remove',
    }
  },
  companies: {
    icon: 'mdi-bank'
  },
  panel: {
    icon: 'mdi-speedometer',
  },
  permissions: {
    icon: 'mdi-key-chain',
    permissionMap: 'mdi-cog',
    whoHas: 'mdi-police-badge',
  },
  promotions: {
    icon: 'mdi-ticket-percent-outline',
    promotions: 'mdi-ticket-percent',
    // promotions: 'mdi-ticket-percent',
    // mgm: 'mdi-account-multiple-plus-outline',
    mgm: 'mdi-ticket-account',
    personal: 'mdi-account-outline',
    other: 'mdi-ticket-percent-outline',
  },
  reports: {
    icon: 'mdi-chart-bar',
  },
  routes: {
    icon: 'mdi-compass-outline',
  },
  serviceProviders: {
    icon: 'mdi-cube-send',
    promotions: 'mdi-ticket-percent',
    services: 'mdi-room-service',
    types: {
      infocard: 'mdi-information-variant-box',
      infocard_sending: 'mdi-information-variant-box',
      offline: 'mdi-minus-circle-outline',
      supermarket: 'mdi-cart',
      services: 'mdi-checkbox-multiple-marked-circle-outline',
      webview: 'mdi-web',
    },
  },
  screensavers: {
    icon: 'mdi-weather-night',
    screensaver: 'mdi-file-image',
  },
  settings: {
    deliveries: 'mdi-clock',
    emails: 'mdi-email',
    icon: 'mdi-cogs',
    landings: 'mdi-airplane-landing',
    holidays: 'mdi-beach',
    modules: 'mdi-view-grid-outline',
    themes: 'mdi-shape',
    translations: 'mdi-translate',
    zones: 'mdi-flag',
    couriers: 'mdi-truck-delivery',
  },
  swagger: {
    icon: 'mdi-api',
  },
  users: {
    icon: 'mdi-account-outline',
    users: 'mdi-account',
    details: 'mdi-card-account-details',
    address: 'mdi-home-city',
    permissions: 'mdi-account-key',
    import: 'mdi-account-multiple-plus-outline',
  },
  standalone: {
    icon: 'mdi-cellphone',
  }, 
  webhooks: {
    icon: 'mdi-link',
  },
}
